export const resolveAllEvents = () => {
  return [ 'eventsService', eventsService => {
    return eventsService.collectAll().then(list => list);
  }];
};
  
export const resolveGroupedEvents = () => {
  return [ 'eventsService', eventsService => {
    return eventsService.collectGrouped().then(list => list);
  }];
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/resolvers/events.resolver.js